import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import { SButton } from '@setvi/shared/components';
import { DownloadIconV2 } from '@setvi/shared/components/sicons';

import { useRFQStore } from 'pages/auto-rfq/store';

const ExportMenu = () => {
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const { isSocketActive, analytics } = useRFQStore();
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    if (!id) return;

    setIsLoading(true);
    try {
      const response = await fetch(
        `https://rfq-email-processor.vercel.app/api/export/cpq-import/${id}`,
        {
          method: 'GET',
          headers: {
            'x-api-key': '8e411a47-f588-4b3e-b71d-2a31473f5cc2'
          }
        }
      );

      if (!response.ok) throw new Error('Export failed');

      const blob = await response.blob();
      const timestamp = Date.now();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `CPQ-Import-${id}-${timestamp}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      enqueueSnackbar('RFQ exported successfully', {
        variant: 'success'
      });
    } catch {
      enqueueSnackbar('Error while exporting RFQ', {
        variant: 'error'
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <SButton
      style={{ borderRadius: 36 }}
      disabled={isSocketActive || isLoading || !analytics?.processed}
      onClick={handleDownload}
      loading={isLoading}
      startIcon={<DownloadIconV2 fill="primary" />}>
      Download
    </SButton>
  );
};

export default ExportMenu;
